import { useQuery } from "@tanstack/react-query";
import { useParams } from "wouter";
import { WorkflowRunInspector } from "@/components/workflows/WorkflowRunInspector";
import { aiWorkflowsService } from "@/services/aiWorkflowsService";

export default function WorkflowRunsPage() {
  const params = useParams<{ runId: string }>();
  const runId = params.runId;

  const { data: workflow } = useQuery({
    queryKey: ["workflow-for-run", runId],
    queryFn: async () => {
      if (!runId) return null;
      const { workflowRunsService } = await import("@/services/workflowRunsService");
      const run = await workflowRunsService.getRun(runId);
      if (!run) return null;
      return aiWorkflowsService.getWorkflowById(run.workflowId);
    },
    enabled: !!runId,
  });

  if (!runId) {
    return <div className="p-8">Missing run ID</div>;
  }

  return (
    <div className="container max-w-3xl py-8">
      <h1 className="text-xl font-semibold mb-4">Workflow Run</h1>
      <WorkflowRunInspector runId={runId} workflow={workflow ?? undefined} />
    </div>
  );
}
